import thumbnailFamilyTravel from '../assets/img/article-square-second.png'
import thumbnailWhenYouFly from '../assets/img/article-square-first.png'
import thumbnailSitaPhone from '../assets/img/article-rectangle-tall.png'
import styled from 'styled-components'

/* Home Page */
const Thumbnail = styled.img`
  border-radius: 7px;
  height: 287px;
  flex: 1;
  min-width: 287px;
  object-fit: cover;
`

const ArticlesWrapper = styled.div`
  margin: 0 auto 2em;
  // max-width: 1059px;
  max-width: 1465px;
  min-height: 240px;
  display: flex;
  gap: 40px;
`

const ArticleBackgroundSquare = styled.div`
  text-align: center;
  box-shadow: 0 0 2px 1px rgba(38, 38, 38, 0.2);
  border-radius: 7px;
  background: #f6f6f6;
  flex: 1;
  min-width: 305px;
  padding: 25px;
`

const ArticleHeaderSquare = styled.h2`
  font-weight: 600;
  font-size: 23px;
  line-height: 22px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;

  color: #000000;
  margin: 25px;
`

const ArticleButtonSquare = styled.button`
  border-radius: 20px;
  border-width: 1px;

  // Custom
  background-color: white;
  color: #000000;
  padding: 0px 30px;
  border: solid;
  border-width: 1px;
  border-radius: 30px;
  height: 30px;
`

const ArticleSquareText = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: -1%;
  text-align: center;
`

const ArticleRow = styled.div`
  display: flex;
  margin-bottom: 30px;
  height: 287px;
  gap: 0px;
  flex: 1;
`

const ArticleRectangleBackground = styled.div`
  text-align: center;
  font-size: 36px;
  line-height: 1.15em;
  background-color: #aa95ff;
  height: 603px;
  flex: 1;
  min-width: 431px;
  max-width: 500px;
  border-radius: 7px;
  padding: 25px;
`

const ArticleRectangleHeader = styled.h2`
  font-weight: 300;
  font-size: 35px;
  line-height: 39px;
  letter-spacing: -4%;
  text-align: center;
  vertical-align: middle;
  vertical-align: middle;
  color: #000000;
  margin-top: 35px;
`

const ArticleRectangleImage = styled.img`
  height: 252px;
  margin: 25px;
`

const ArticleRectangleText = styled.p`
  font-weight: 400;
  font-size: 15px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
`

const ArticleRectangleButton = styled.button`
  // Figma
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  width: 158px;
  height: 40px;

  // Custom
  background-color: transparent;
  color: #000000;
  padding: 0px 30px;
  border: solid;
  border-width: 1px;
  border-radius: 20px;
`

function Articles(props) {
  return (
    <ArticlesWrapper>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <ArticleRow>
          <ArticleBackgroundSquare>
            <ArticleHeaderSquare>
              What to expect <br></br>
              when you fly
            </ArticleHeaderSquare>
            <ArticleSquareText>
              The airline experience is rapidly changing every <br></br>
              day. Come prepared and stress-free with the <br></br>
              help of our useful guide on how to navigate your <br></br>
              traveling experience in a post-Covid world.
            </ArticleSquareText>
            <ArticleButtonSquare>Learn more</ArticleButtonSquare>
          </ArticleBackgroundSquare>

          <Thumbnail src={thumbnailWhenYouFly} alt="When you fly" />
        </ArticleRow>
        <ArticleRow>
          <ArticleBackgroundSquare>
            <ArticleHeaderSquare>
              Family bundles <br></br>
              available
            </ArticleHeaderSquare>
            <ArticleSquareText>
              Plan an unforgettable adventure for the <br></br>
              whole family. Our comprehensive family <br></br>
              travel packages offer flights, hotels, car <br></br>
              rentals and more at affordable rates.
            </ArticleSquareText>
            <ArticleButtonSquare>See deals</ArticleButtonSquare>
          </ArticleBackgroundSquare>
          <Thumbnail src={thumbnailFamilyTravel} alt="Family travel" />
        </ArticleRow>
      </div>

      <ArticleRectangleBackground>
        <ArticleRectangleHeader>
          ENHANCE YOUR TRIP <br></br>
          WITH THE APP
        </ArticleRectangleHeader>
        <ArticleRectangleImage src={thumbnailSitaPhone}></ArticleRectangleImage>
        <ArticleRectangleText>
          Book trips fast, get special promotions, enjoy <br></br>
          in-flight entertainment and more with the SITA Air app.
        </ArticleRectangleText>
        <ArticleRectangleButton>Get the app</ArticleRectangleButton>
      </ArticleRectangleBackground>
    </ArticlesWrapper>
  )
}

export default Articles
